import { useLanguage } from "../context/LanguageContext";
import { MapPin } from "lucide-react";

const ExperienceSection = ({ experience }) => {
  const { language, t } = useLanguage();

  const getLocalizedText = (field) => {
    if (typeof field === 'string') return field;
    return language === 'no' ? field.no : field.en;
  };

  return (
    <section data-testid="experience-section" className="py-16 md:py-24 border-t border-slate-200">
      <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-800 mb-12 animate-fade-in-up">
        {t('Yrkeserfaring', 'Work Experience')}
      </h2>

      <div className="space-y-0">
        {experience.map((exp, index) => (
          <div
            key={index}
            data-testid={`experience-item-${index}`}
            className="group relative pl-8 pb-10 last:pb-0 border-l-2 border-slate-200 hover:border-sky-500 transition-colors duration-300 animate-fade-in-up"
            style={{ animationDelay: `${(index + 1) * 50}ms` }}
          >
            {/* Timeline dot */}
            <div className="absolute left-[-9px] top-0 w-4 h-4 rounded-full bg-slate-200 group-hover:bg-sky-500 transition-colors duration-300" />
            
            <div className="mb-2">
              <span className="text-sm text-sky-600 font-medium">
                {getLocalizedText(exp.dates)}
              </span>
            </div>
            
            <h3 className="text-xl font-semibold text-slate-900 mb-1">
              {getLocalizedText(exp.role)}
            </h3>
            
            <div className="flex items-center gap-4 mb-3">
              <span className="text-slate-700 font-medium">{exp.company}</span>
              <span className="flex items-center gap-1 text-slate-500 text-sm">
                <MapPin className="w-3 h-3" />
                {exp.location}
              </span>
            </div>
            
            <p className="text-slate-600 leading-relaxed">
              {getLocalizedText(exp.description)}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ExperienceSection;
